export { Card, ContentCards, ClassicCard } from '@braze/web-sdk';
export var loadBrazeSDK = function () {
    return import(/* webpackChunkName: "braze-web-sdk" */ '@braze/web-sdk');
};
